import React from 'react';
import "./footer.css"

const Footer = () => {
    return (
        <footer className="d-flex justify-content-center align-items-center position-fixed text-center w-100  footer">
            <span className="text-white text-center text-s">
                <span dir='ltr' className="d-none d-sm-inline">.کلیه حقوق این سایت متعلق به سروش پلاس می باشد و استفاده از مطالب با ذکر منبع بلامانع است</span>
                <a href="mailto:support@splus.ir" target="_blank"><span className="text-white text-center"> ایمیل پشتیبانی: support@splus.ir</span></a></span>
        </footer>
    );
}

export default Footer;